module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerloi01",
      "epub:type": "frontmatter",
      "id": "loi"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerloi01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0005#toc"
    }
  }, [_vm._v("Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0007#fig000i"
    }
  }, [_vm._v("Figure 0.1.   ")]), _vm._v("A plainclothes decoy with the Los Angeles Police Department waiting on a street corner in 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0008#fig0101"
    }
  }, [_vm._v("Figure 1.1.   ")]), _vm._v("A peek inside a Greenwich Village gay bar in "), _c('i', [_vm._v("Call Her Savage")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0008#fig0102"
    }
  }, [_vm._v("Figure 1.2.   ")]), _vm._v("“Helen Morgan Jr. and Jean Malin at the Smart Club Abbey,” in "), _c('i', [_vm._v("Vanity Fair")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0010#fig0301"
    }
  }, [_vm._v("Figure 3.1.   ")]), _vm._v("Officer Max K. Hurlbut outside Ferndell No. 9 in Griffith Park, Los Angeles.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0011#fig0401"
    }
  }, [_vm._v("Figure 4.1.   ")]), _vm._v("“A policeman in tight-pants disguise,” per "), _c('i', [_vm._v("Life")]), _vm._v(" magazine in 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0011#fig0402"
    }
  }, [_vm._v("Figure 4.2.   ")]), _vm._v("A Los Angeles Police Department decoy speaks with a suspect in Hollywood.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0011#fig0403"
    }
  }, [_vm._v("Figure 4.3.   ")]), _vm._v("“Playing ‘footsie’ in a ‘tearoom,’” in Denny Pace’s "), _c('i', [_vm._v("Handbook of Vice Control")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0011#fig0404"
    }
  }, [_vm._v("Figure 4.4.   ")]), _vm._v("“A toilet snipe looking for a date,” in Denny Pace’s "), _c('i', [_vm._v("Handbook of Vice Control")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0012#fig0501"
    }
  }, [_vm._v("Figure 5.1.   ")]), _vm._v("The interior of the men’s room in Mansfield’s Central Park, as printed in the "), _c('i', [_vm._v("FBI Enforcement Bulletin")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0012#fig0502"
    }
  }, [_vm._v("Figure 5.2.   ")]), _vm._v("A diagram of the Central Park men’s room, drawn by Lieutenant Bill Spognardi of the Mansfield Police Department.")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0012#fig0503"
    }
  }, [_vm._v("Figure 5.3.   ")]), _vm._v("Lieutenant Bill Spognardi manning a hidden camera in the Central Park men’s room, as printed in the "), _c('i', [_vm._v("FBI Enforcement Bulletin")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0013#fig0601"
    }
  }, [_vm._v("Figure 6.1.   ")]), _vm._v("The “frantic hour” on Los Angeles’s Main Street, in "), _c('i', [_vm._v("Life")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0013#fig0602"
    }
  }, [_vm._v("Figure 6.2.   ")]), _vm._v("“A homosexual sits on a rail in Los Angeles’s Pershing Square,” in "), _c('i', [_vm._v("Life")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0013#fig0603"
    }
  }, [_vm._v("Figure 6.3.   ")]), _vm._v("Urban gay street life in New York City, in "), _c('i', [_vm._v("Life")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0013#fig0604"
    }
  }, [_vm._v("Figure 6.4.   ")]), _vm._v("A decoy and his partner arrest a suspect in Hollywood, in "), _c('i', [_vm._v("Life")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilvovsky0013#fig0605"
    }
  }, [_vm._v("Figure 6.5.   ")]), _vm._v("The cover of the “Purple Pamphlet.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba9109e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lvovsky-0006.vue
// module id = 69
// module chunks = 0